import { useEffect, useState } from 'react'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import { QA_NAME_MODAL_ATTENTION } from '../../../constants/qa'
import { FormModal } from '../../Form'
import { MODAL_HEADER_VARIANT } from '../../Modal'
import { TableExportGetResponseLinkTypeModal } from '../TableExportGetResponseLinkTypeModal'

import { FormFields } from './FormFields'
import {
  INITIAL_VALUES,
  QA_NAME_MODAL_EXPORT_TABLE,
} from './TableExportModal.constants'
import {
  getAdditionalParam,
  getSelectedFieldIdsFromOptions,
  getSelectedParams,
} from './TableExportModal.utils'

import * as styles from './TableExportModal.module.css'

function TableExportModal({
  Fields = FormFields,
  checkTask,
  formModalProps: {
    containerProps = EMPTY_OBJECT,
    formBodyProps = EMPTY_OBJECT,
    formTitle = 'Modal.ExportDataTitleKey',
    submitButtonText = 'Modal.ExportDataBtnKey',
    ...restFormModalProps
  } = EMPTY_OBJECT,
  getAdditionalParamFromValues = getAdditionalParam,
  getSelectedFieldIds = getSelectedFieldIdsFromOptions,
  getSelectedParamsFromValues = getSelectedParams,
  initialValues = INITIAL_VALUES,
  loadFieldList,
  qaName = QA_NAME_MODAL_EXPORT_TABLE,
  startExport,
  tableExportGetResponseLinkModalProps = EMPTY_OBJECT,
  onClose,
}) {
  const [options, setOptions] = useState(EMPTY_LIST)
  const [selected, setSelected] = useState(EMPTY_LIST)
  const [additionParams, setAdditionParams] = useState(EMPTY_OBJECT)
  const [loading, setLoading] = useState(true)
  const [attention, setAttention] = useState(false)

  useEffect(() => {
    loadFieldList()
      .then(data => {
        setOptions(data.data)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  function handleShowAttention({ values }) {
    setAdditionParams(getAdditionalParamFromValues(values))
    setSelected(getSelectedParamsFromValues(getSelectedFieldIds(values)))
    setAttention(true)
  }

  function handleStartExport(params) {
    return startExport({ ...params, fields: selected, ...additionParams })
  }

  if (attention) {
    return (
      <TableExportGetResponseLinkTypeModal
        {...tableExportGetResponseLinkModalProps}
        qaName={QA_NAME_MODAL_ATTENTION}
        onCancel={onClose}
        onCheckTask={checkTask}
        onClose={onClose}
        onStartExport={handleStartExport}
      />
    )
  }

  return (
    <FormModal
      {...restFormModalProps}
      Fields={Fields}
      containerProps={{
        headerVariant: MODAL_HEADER_VARIANT.EDIT,
        ...containerProps,
        qaName,
      }}
      formBodyProps={{
        ...formBodyProps,
        actionsProps: {
          ...formBodyProps?.actionsProps,
          cancelProps: {
            isSkeleton: loading,
          },
          className: styles.footer,
          submitProps: {
            isSkeleton: loading,
          },
        },
        submitButtonText,
      }}
      formFieldsProps={{ loading, options }}
      formTitle={formTitle}
      initialValues={initialValues}
      onClose={onClose}
      onSubmit={handleShowAttention}
    />
  )
}

export default TableExportModal
